import { PlacementWorksheetTable as View } from "./PlacementWorksheetTable";
import { withPlacementWorksheetTableProvider } from "./PlacementWorksheetTableProvider";

export const PlacementWorksheetTable = withPlacementWorksheetTableProvider(View);
